import { ContentType } from 'services/data-manager/types';

export const EMPTY_COLLECTION_ITEM_ID = 'EMPTY_COLLECTION_ITEM_ID';

export type EmptyCollectionItem = {
    id: typeof EMPTY_COLLECTION_ITEM_ID;
    type: ContentType;
};

function createEmptyItem(type: ContentType): EmptyCollectionItem {
    return {
        id: EMPTY_COLLECTION_ITEM_ID,
        type,
    };
}

export default createEmptyItem;
